import { Component } from '@angular/core';
import { AuthSession } from '../../models/profile';
import { AuthService } from '../../services/auth.service';
import { Router, UrlTree } from '@angular/router';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './redirect.component.html',
})
export class RedirectComponent {
  authToken: AuthSession | undefined;
  error = '';
  code = '';

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
    this.redirect();
  }

  redirect(): UrlTree | void {
    const profile = this.authService.getProfile();
    if (!profile) {
      return this.router.parseUrl('/auth');
    }
    this.router.navigate(['/dashboard']);
  }
}
